<template>
  <v-row v-if="isInspectionLawsuit(caseData)">
    <template>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.inspectionCity"
          :value.sync="cityId"
          :items="citiesByCourtType[courtTypeId]"
          :disabled="!(citiesByCourtType[courtTypeId] || []).length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="generalSpecializedLocationChanged"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="cityCourtByType[cityId]"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
      </v-col>
    </template>
  </v-row>
  <v-row v-else>
    <v-col
      v-if="selectedCaseType"
      cols="12"
      lg="4"
    >
      <naj-input
        :type-id="formFieldType.selectbox"
        :label="local.lawsuitDetails.specializedLocation"
        :value.sync="specializedLocationId"
        :items="filteredGeneralSpecializedLocationCourtOptions"
        :disabled="disabled"
        item-value="id"
        item-text="name"
        :validates="'required'"
        @change="specializedLocationChanged"
      ></naj-input>
    </v-col>
    <template v-if="specializedLocationId && specializedLocationId!==3">
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="specializedLocationId==1?local.lawsuitDetails.agreedCourt: specializedLocationId == 2 ? local.lawsuitDetails.companyBranchCity : local.lawsuitDetails.governmentBranchCity "
          :value.sync="cityId"
          :items="citiesByCourtType[courtTypeId]"
          :disabled="!(citiesByCourtType[courtTypeId] || []).length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="generalSpecializedLocationChanged"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="cityCourtByType[cityId]"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
        <span
          v-if="specializedLocationId==2"
          class="user-attention"
        >
          {{ local.lawsuitDetails.companyBranchAttention }}
        </span>
        <span
          v-if="specializedLocationId==4"
          class="user-attention"
        >
          {{ local.lawsuitDetails.governmentBranchAttention }}
        </span>
      </v-col>
    </template>
    <template v-if="specializedLocationId===3">
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="closestCourts"
          :disabled="disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="updateCourtId"
        ></naj-input>
        <span
          v-if="caseData.isRelatedToCorona"
          class="user-attention"
        >
          {{ local.lawsuitDetails.coronaAttention }}
        </span>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { caseClassificationEnum, partyTypeEnum } from '@/helpers/enum';
import { isGeneralLawsuit, isInspectionLawsuit } from '../../../helpers/utils';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapLUTActions, mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'partiesInfo', 'disabled', 'handleGetCourtsInvoker', 'disableLocationSpecializationRule'],
  data() {
    return {
      isGeneralLawsuit,
      isInspectionLawsuit,
      closestCourts: [],
      cityId: null,
      specializedLocationId: null,
    };
  },
  computed: {
    ...mapState({
      caseData: state => state.lawsuitRequest.case,
      caseParties: state => state.lawsuitRequest.caseParties,
    }),
    ...mapLUTState(['citiesByCourtType', 'cityCourtByType', 'generalSpecializedLocationCourtOptions']),
    ...mapGetters(['selectedCaseType']),
    courtTypeId() {
      return this.isGeneralLawsuit(this.caseData) ? caseClassificationEnum.general : 0;
    },
    isCaseTypeRelatedToGovernmentBranch() {
      return this.caseParties.some(x => x.partyType == partyTypeEnum.government);
    },
    isCaseTypeRelatedToCompanyBranch() {
      return this.selectedCaseType && this.selectedCaseType.isCaseTypeRelatedToCompanyBranch;
    },
    filteredGeneralSpecializedLocationCourtOptions() {
      if (this.isCaseTypeRelatedToCompanyBranch && this.isCaseTypeRelatedToGovernmentBranch)
        return this.generalSpecializedLocationCourtOptions;
      else if (this.isCaseTypeRelatedToCompanyBranch)
        return this.generalSpecializedLocationCourtOptions.filter(item => item.id !== 4);
      else if (this.isCaseTypeRelatedToGovernmentBranch)
        return this.generalSpecializedLocationCourtOptions.filter(item => item.id !== 2);
      return this.generalSpecializedLocationCourtOptions.filter(item => item.id !== 2 && item.id !== 4);
    },
  },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker);
    },
    'specializedLocationId': function (value) {
      if (value)
        this.handleGetCourts('specializedLocationId');
      this.$set(this.caseData, 'specializedLocationId', value);
      if (this.filteredGeneralSpecializedLocationCourtOptions.some(x => x.id == this.specializedLocationId) == false) {
        this.specializedLocationId = null;
        this.cityId = null;
        this.courtId = null;
      }
    },
    'cityId': function (value) {
      this.$set(this.caseData, 'cityId', value);
    },
  },
  mounted() {
    this.cityId = this.caseData.cityId || null;
    this.specializedLocationId = this.caseData.specializedLocationId || null;
    this.handleGetCourts('mounted');
  },

  methods: {
    ...mapActions(['getPartiesClosestCourts']),
    ...mapLUTActions(['getCitiesByCourtType', 'getGeneralCityCourtByType']),
    handleGetPartiesClosestCourts(invoker) {
      const caseTypeId = this.caseData.caseTypeId || null;
      const caseCategoryId = this.caseData.caseCategoryId || null;
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      const accidentCityId = this.cityId || null;
      const disableLocationSpecializationRule = this.disableLocationSpecializationRule || null;
      const isRelatedToCorona = this.caseData.isRelatedToCorona || null;
      if (caseTypeId && caseCategoryId && caseClassificationId && (this.partiesInfo || []).length) {
        const data = {
          invoker,
          caseTypeId,
          caseCategoryId,
          caseClassificationId,
          accidentCityId,
          disableLocationSpecializationRule,
          isRelatedToCorona,
          partiesInfo: this.partiesInfo,
          form: (this.caseData.forms || [])[0],
        };
        this.getPartiesClosestCourts(data)
          .then(({ data }) => {
            this.closestCourts = data.data;
            this.$emit('courtsRetrieved', this.closestCourts);
          });
      }
    },
    specializedLocationChanged() {
      this.updateCourtId(null);
      this.cityId = null;
      this.getCitiesByCourtType(this.courtTypeId);
    },
    generalSpecializedLocationChanged() {
      this.updateCourtId(null);
      this.getGeneralCityCourtByType(this.cityId)
        .then((cityCourt) => {
          this.updateCourtId((cityCourt || [{ id: null }])[0].id);
        });

    },
    handleGetCourts(invoker) {
      if ((this.isGeneralLawsuit(this.caseData) && this.specializedLocationId !== 3)) {
        this.getCitiesByCourtType(this.courtTypeId);
        if (this.cityId)
          this.getGeneralCityCourtByType(this.cityId);
      }
      else
        this.handleGetPartiesClosestCourts(invoker);
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
